/**
 * O resto das informações de um pagamento — o que não cabe na linha da tabela.
 *
 * A tabela carrega o que se compara entre pagamentos (valor, meio, tipo, pagador, conta, estado);
 * aqui ficam os identificadores e o rastro de quem registrou, que só interessam quando alguém já
 * escolheu uma linha para investigar.
 */
import { FaTimes } from 'react-icons/fa';

import { PaymentRow } from '../services/billingApi';
import { formatBRL } from '../../../../utils/currencyUtils';
import { formatTaxId } from '../../../../utils/taxIdUtils';
import { STATUS_META } from '../PaymentsPanel';

const Linha: React.FC<{ label: string; value?: React.ReactNode }> = ({ label, value }) => (
    <div className="flex justify-between gap-4 py-1.5 border-b dark:border-slate-700 last:border-0">
        <span className="text-gray-500 dark:text-gray-400">{label}</span>
        <span className="text-right font-medium break-all">{value ?? '—'}</span>
    </div>
);

/** Instante em UTC → leitura local, que é o dia que a tela filtra. */
const instante = (iso: string | null) =>
    iso ? new Date(iso).toLocaleString('pt-BR') : null;

interface Props {
    payment: PaymentRow;
    onClose: () => void;
}

const PaymentInfoModal: React.FC<Props> = ({ payment, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-lg" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between px-6 py-4 border-b dark:border-slate-600">
                <h3 className="text-lg font-semibold">Informações do pagamento</h3>
                <button onClick={onClose} aria-label="Fechar"
                    className="text-gray-400 hover:text-gray-600"><FaTimes /></button>
            </div>
            <div className="px-6 py-4 text-sm">
                <Linha label="Identificador" value={payment.paymentId} />
                <Linha label="Estado" value={STATUS_META[payment.status].label} />
                <Linha label="Valor" value={payment.amount != null ? formatBRL(payment.amount) : null} />
                <Linha label="Data do pagamento" value={instante(payment.paymentDate)} />
                <Linha label="Pagador" value={payment.payer?.name} />
                <Linha label="Documento"
                    value={payment.payer?.documentNumber ? formatTaxId(payment.payer.documentNumber) : null} />
                <Linha label="Conta de recebimento" value={payment.receivingBankAccount?.exibitionName} />
                <Linha label="Faturas sinalizadas" value={payment.linkedInvoicesCount} />
                <Linha label="Valor sinalizado" value={formatBRL(payment.markedAmount)} />
                <Linha label="Registrado por" value={payment.userResponsible} />
                <Linha label="Recibo" value={payment.fileNameReceipt} />
                <Linha label="Criado em" value={instante(payment.createdAt)} />
            </div>
        </div>
    </div>
);

export default PaymentInfoModal;
